import { render, staticRenderFns } from "./BeautyNicheIcon.vue?vue&type=template&id=557d2d46&scoped=true"
import script from "./BeautyNicheIcon.vue?vue&type=script&lang=js"
export * from "./BeautyNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d2d46",
  null
  
)

export default component.exports